const setGraphData_transfer_acc = payload => {
  return {
    type: "setGraphData_transfer_acc",
    payload
  };
};
export default setGraphData_transfer_acc;
